const localizeAuthError = (error, t) => {
  const backendMsg = error?.response?.data?.message;
  if (!backendMsg) return null;

  const lower = backendMsg.toLowerCase();

  if (/no encontrad|not found/.test(lower)) {
    return t.userNotFound || "User not found";
  }
  if (/registrad|already registered|ya existe|already exist|already used|tomado/i.test(lower)) {
    return t.emailAlreadyRegistered || "This email is already registered";
  }
  if (/(contraseña|password).*(incorrect|wrong|inv[aá]lid)|(incorrect|wrong)\s+(contraseña|password)/i.test(lower)) {
    return t.incorrectPassword || "Incorrect password";
  }
  if (/invalid|inv[aá]lid|credencial|no v[aá]lid|incorrect|email.*not|correo.*no/i.test(lower)) {
    return t.invalidCredentials || "Invalid email or password";
  }

  return backendMsg;
};

export default localizeAuthError;